export const L10N = {
  ACTION_SEE_OPTIONS: { id: 'core.action.see_options' },

  LABEL_FOR_NIGHTS: { id: 'common.label.for_nights' },
  LABEL_FROM: { id: 'common.label.from' },
  LABEL_IMMERSIVE_BOOKING: { id: 'core.label.immersive_booking' },
  LABEL_NOT_AVAILABLE: { id: 'common.label.not_available' },
  LABEL_PER_NIGHT: { id: 'core.label.per_night' },
};
